const React = require('react');
const ButtonBack = require('../../../dumb/Button/BackB');
const Caption = require('../../../dumb/Caption/C');
const Loading = require('../../../dumb/Loading');
const {MerchantTextarea} = require('../../../dumb/FormInputs/');
const {FormWrapper, FormFooter} = require('../../../dumb/FormHandlers/');

const {pushLocation} = require('../../../../router');
const {LINK_DASHBOARD, LINK_CREATE_CRYPTO_WALLET, LINK_WITHDRAW} = require('../../../../constants/links');
const withState = require('../../../../utils/withState');
const {LINK_CREATE_APP} = require('../../../../constants/links');


const getMountData = require('./utils/getMountData');
const withdrawFormSchema = require('./utils/withdrawFormSchema').default;
const formInnerHandler = require('./utils/formInnerHandler');
const onFormSubmit = require('./utils/onFormSubmit');
const formResultMessage = require('./utils/formResultMessage');

const Balances = require('./components/Balances');
const SelectBlock = require('./components/SelectBlock');
const {paramStore} = require("../../../../stores");

module.exports = withState((setState, self, onMount) => {
  const dashboardLink = LINK_DASHBOARD;

  self.state = {
    ...self.state,
    loading: true,
  };

  const backToDashboard = () => (
    pushLocation({
      path: dashboardLink,
    })
  );

  onMount(() => {
    const assetCode = (self.props.params || {}).assetCode;

    if (!assetCode) {
      backToDashboard();
      return;
    }

    const appId = paramStore('appId').getValue();
    const walletId = paramStore('walletId').getValue();

    getMountData({assetCode, appId, walletId, backToDashboard}).then((res) => {
      setState({...res, assetCode, loading: false});
    });
  });

  return (state, props) => {
    const {assetCode, appBalance, app_id, crypto_wallet_id, appsList = [], walletsList = [], availableBalance = '0', loading} = state;

    return (
      <div className={'wmin400 wmax1000 ' + (props.className || '')}>
        <div className="layoutRow fhaB fvaC">
          <ButtonBack
            className="m-10 mr10"
            onClick={backToDashboard}
          />
          <Caption>Manual Withdrawal</Caption>
        </div>
        {loading
          ? <Loading/>
          : Number(availableBalance) > 0
            ? (
            <FormWrapper
              data={{assetCode, appBalance, walletsList, app_id, crypto_wallet_id}}
              schema={withdrawFormSchema}
              onSubmit={onFormSubmit}
              resultModalHandler={formResultMessage}
              onResult={backToDashboard}
            >{(formCtx) => {
                const {
                  appBalance,
                  appSelectProps,
                  walletSelectProps,
                  walletCreationLink,
                } = formInnerHandler({
                  assetCode,
                  appsList,
                  formCtx,
                });

                const firstWalletInList = walletSelectProps.items ? walletSelectProps.items[0] : {};
                const disableSubmitBtn = !appSelectProps.value
                  || (firstWalletInList && firstWalletInList.disabled)
                  || appBalance === '0';

                  return (
                    <>
                    <div className="layoutRow mt7 mh-25 (w1/2|ph25)>1">
                      <div className="(mv20)>1">
                        <SelectBlock
                          selectProps={appSelectProps}
                          btnProps={{link: `${LINK_CREATE_APP}?backPath=withdraw&asset=${assetCode}`}}
                        />
                        <SelectBlock
                          selectProps={walletSelectProps}
                          btnProps={{
                            link: walletCreationLink || '#',
                            disabled: !walletCreationLink,
                          }}
                        />
                      </div>
                      <div className="mt20">
                        <Balances
                          appBalance={appBalance}
                          availableBalance={availableBalance}
                          assetCode={assetCode}
                        />
                      </div>
                    </div>
                    <div className="mt20">
                      <MerchantTextarea
                        name="description"
                        maxLength={15000}
                        formCtx={formCtx}
                      />
                    </div>
                    <FormFooter
                      submitBtnData={{
                        text: 'Withdraw',
                        formCtx,
                        disabled: disableSubmitBtn,
                        changesCheckDisabled: app_id && crypto_wallet_id
                      }}
                    />
                  </>
                );
              }}</FormWrapper>
          ) : (
              <div className="mt20">
                Available balance ({availableBalance} {assetCode}) is lower or equal zero. You can't perform withdrawal tight now.
              </div>
            )
        }
      </div>
    );
  };
});
